@let filters = savedFilters();
@if (filters) {
  <div class="or-d-flex overflow-x-auto or-pl-8-px or-pr-8-px or-mt-16-px">
    @for (day of daysRange(); track day.date) {
      <div
        (click)="setDate(day)"
        class="or-head-sm or-mr-4-px or-p-8-px or-d-flex or-justify-content-center or-cursor-pointer text-no-wrap"
        [ngClass]="day.isSelected ? checkedClasses : uncheckedClasses">
        <div class="or-d-flex or-align-items-center or-justify-content-center">
          <div
            class="or-text-transform-capitalize-first-letter or-mr-8-px"
            [ngClass]="day.isSelected ? checkedTextClasses : ''">
            {{ day.dayAbbreviation }}
          </div>
          <div>{{ day.date }}</div>
        </div>
      </div>
    }
  </div>

  <div class="or-px-12-px or-d-flex or-mt-8-px overflow-x-auto">
    @if (!areFiltersDefault()) {
      <or-icon (click)="resetFilters()" name="close" size="s" boxed class="or-mr-8-px or-bg-main-1 or-color-white" />
    }

    @if (showAlertsFilter() && alerts(); as alertsSettings) {
      <div
        (click)="goToAlerts(alertsSettings.isEnabled)"
        class="border-shade border-radius-4 or-d-flex or-mr-12-px or-p-8-px or-text-md text-no-wrap or-align-items-center or-cursor-pointer filters__location--cta">
        <or-icon name="alerts" size="xs" class="or-mr-4-px or-color-white" />
        <div>{{ alertsSettings.isEnabled ? 'Edytuj alerty' : 'Włącz alerty' }}</div>
      </div>
    }
    @if (showDistanceFilter()) {
      <div
        class="border-shade border-radius-4 or-d-flex or-mr-12-px or-p-8-px or-text-md text-no-wrap or-align-items-center"
        [ngClass]="!selectedLocation() ? 'filters__location--cta' : 'or-bg-white'">
        <div (click)="openLocationPicker()" class="or-d-flex or-align-items-center or-cursor-pointer">
          @if (selectedLocation()) {
            <div class="or-color-secondary-2 or-mr-4-px">Lokalizacja:</div>
            <div>{{ selectedLocation()?.name }}</div>
          } @else {
            <div>Zlokalizuj się</div>
          }
          <img src="assets/icons/dropdown-icon.svg" class="or-ml-8-px" />
        </div>
        @if (selectedLocation()) {
          <ion-icon
            name="close"
            (click)="clearLocation()"
            class="or-ml-8-px or-color-secondary-2 or-cursor-pointer"></ion-icon>
        }
      </div>
    }

    @if (showDistanceFilter() && selectedLocation()) {
      <div
        (click)="openDistanceFilter()"
        class="border-shade border-radius-4 or-d-flex or-mr-12-px or-bg-white or-p-8-px or-text-md text-no-wrap or-align-items-center or-cursor-pointer">
        <div class="or-color-secondary-2 or-mr-4-px">Odległość:</div>
        <div>{{ getDistanceName(filters.maxDistanceMeters) }}</div>
        <img src="assets/icons/dropdown-icon.svg" class="or-ml-8-px" />
      </div>
    }

    <div
      (click)="openGameLevel()"
      class="border-shade border-radius-4 or-d-flex or-mr-12-px or-bg-white or-p-8-px or-text-md text-no-wrap or-align-items-center">
      <div class="or-color-secondary-2 or-mr-4-px">Poziom:</div>
      <div>{{ getGameLevelName(filters.gameLevel) }}</div>
      <img src="assets/icons/dropdown-icon.svg" class="or-ml-8-px" />
    </div>

    <div
      (click)="openLocationType()"
      class="border-shade border-radius-4 or-d-flex or-bg-white or-p-8-px or-text-md text-no-wrap or-align-items-center"
      [class.or-mr-12-px]="showGameVisibilityFilter()">
      <div class="or-color-secondary-2 or-mr-4-px">Typ boiska:</div>
      <div>{{ getLocationTypeName(filters.locationType) }}</div>
      <img src="assets/icons/dropdown-icon.svg" class="or-ml-8-px" />
    </div>

    @if (showGameVisibilityFilter()) {
      <div
        (click)="openGameVisibility()"
        class="border-shade border-radius-4 or-d-flex or-bg-white or-p-8-px or-text-md text-no-wrap or-align-items-center">
        <div class="or-color-secondary-2 or-mr-4-px">Widoczność:</div>
        <div>{{ getGameVisibilityName(filters.showPrivateBlurred) }}</div>
        <img src="assets/icons/dropdown-icon.svg" class="or-ml-8-px" />
      </div>
    }
  </div>
}
